import { Alert, AlertIcon, AlertTitle, AlertDescription, Flex, Button } from '@chakra-ui/react';

import { getTrackerStatus, TrackerStep } from 'shared-components';

import { ISummary } from '../../../../types';

export interface IProps {
  summary: ISummary;
  onClick: () => void;
}

const TrackerReminder = (props: IProps) => {
  const { summary, onClick } = props;
  const { step } = getTrackerStatus(summary);

  return (
    <Alert
      data-selector="cas-tracker-reminder"
      status={step === TrackerStep.CAS_ISSUED ? 'success' : 'info'}
      justifyContent="center"
      mb={6}
      py={4}
    >
      <AlertIcon />

      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        flexGrow="1"
        columnGap={2}
        rowGap={2}
        alignItems={{ base: 'start', md: 'center' }}
      >
        <AlertTitle flexGrow="1" fontSize="lg" fontWeight="medium">
          {step === TrackerStep.CAS_ISSUED ? 'Your CAS has been issued' : 'We are processing your CAS'}
        </AlertTitle>

        <AlertDescription>
          <Button
            onClick={onClick}
            variant="solid"
            colorScheme={step === TrackerStep.CAS_ISSUED ? 'green' : 'blue'}
            my={{ base: undefined, md: -2 }}
            data-selector="cas-tracker-reminder-button"
          >
            {step === TrackerStep.CAS_ISSUED ? 'Learn more' : 'Track progress'}
          </Button>
        </AlertDescription>
      </Flex>
    </Alert>
  );
};

export default TrackerReminder;
